/**
 * @generated SignedSource<<d48209b73ed879470e3dfa504398a161>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BaseProjectVersionApprovalButtonDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  projectVersionApprovalId: string;
};
export type BaseProjectVersionApprovalButtonDeleteMutation$data = {
  readonly deleteProjectVersionApproval: string;
};
export type BaseProjectVersionApprovalButtonDeleteMutation = {
  response: BaseProjectVersionApprovalButtonDeleteMutation$data;
  variables: BaseProjectVersionApprovalButtonDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectVersionApprovalId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "projectVersionApprovalId",
    "variableName": "projectVersionApprovalId"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "deleteProjectVersionApproval",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BaseProjectVersionApprovalButtonDeleteMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "BaseProjectVersionApprovalButtonDeleteMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteProjectVersionApproval",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d0fd0f5f6ba3af57ba5dfe662481d902",
    "id": null,
    "metadata": {},
    "name": "BaseProjectVersionApprovalButtonDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BaseProjectVersionApprovalButtonDeleteMutation(\n  $projectVersionApprovalId: ID!\n) {\n  deleteProjectVersionApproval(projectVersionApprovalId: $projectVersionApprovalId)\n}\n"
  }
};
})();

(node as any).hash = "da9025f520d8dfb63d010779fb8332f7";

export default node;
